const modalApp = Vue.createApp({
    template: `<transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" :class="modalClass" @click="close()">
        <div class="modal-container" @click.stop="">
          <div class="modal-header" v-html="modalHeader"></div>
          <div class="modal-body" v-html="modalBody"></div>
          <div class="modal-footer" ref="modalFooter" v-html="modalFooter"></div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`,
    watch: {
        'showModal': {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        const button = this.$refs.modalFooter.querySelector('.open-sample-modal-trigger');
                        if(button) {
                            button.addEventListener('click', this.openSampleModal);
                        }
                    });
                } else if(oldVal && !newVal) {
                    const button = this.$refs.modalFooter.querySelector('.open-sample-modal-trigger');
                    if(button) {
                        button.removeEventListener('click',  this.openSampleModal);
                    }
                }
            },
            immediate: true
        }
    },
    beforeUnmount() {
        if(this.$refs.modalFooter) {
            console.log('Footer ref before unmount');
        }
    },
    computed: {
        showModal() {
            return store.getters['modal/show'];
        },
        modalClass() {
            return store.getters['modal/modalClass'];
        },
        modalHeader() {
            return store.getters['modal/modalHeader'];
        },
        modalBody() {
            return store.getters['modal/modalBody'];
        },
        modalFooter() {
            return store.getters['modal/modalFooter'];
        }
    },
    methods: {
        close() {
            store.dispatch('modal/close')
        },
        openSampleModal() {
            let product = sessionStorage.getItem('last-sample-product');
            if(product) {
                this.close();
                product = JSON.parse(product);
                const img = new Image();
                img.onload = () => {
                    const width = img.width
                    const height = img.height
                    product.imageWidth = width;
                    product.imageHeight = height;
                    store.dispatch('samplePopup/set', {'item': product, 'croppedFile': null, 'files': null});
                    store.dispatch('samplePopup/open');
                }
                img.src = product.thumbnail_url;
            }
        }
    }
})
modalApp.use(store);
modalApp.mount('#modal-app');

// Sample materials are managed in admin via the "sample_material" metaobject and
// injected as JSON by snippets/sample-materials-data.liquid. Parsed once and cached.
let cachedSampleMaterials;
function getSampleMaterialsData() {
    if (cachedSampleMaterials !== undefined) {
        return cachedSampleMaterials;
    }
    try {
        const el = document.getElementById('sample-materials-json');
        const data = el ? JSON.parse(el.textContent) : [];
        cachedSampleMaterials = Array.isArray(data) ? data : [];
    } catch (e) {
        cachedSampleMaterials = [];
    }
    return cachedSampleMaterials;
}

const samplePopupApp = Vue.createApp({
    data() {
        return {
            materials: [],
            errors: null,
            loading: false,
            tabs: {
                "additional_materials": {
                    "collapsed": true
                },
            }
        }
    },
    template: `<transition name="modal">
    <div class="modal-mask" v-if="showModal">
      <div class="modal-wrapper" @click="close()">
        <div class="modal-container sample-popup-container" @click.stop="">
          <div class="modal-body">
            <div class="sample-order-form">
              <form action="/" method="post" @submit.prevent="onSubmit">
                <div class="sample-form" :class="{'loading': loading}">
                  <h3 class="sample-title">Request A Sample</h3>
                  <div class="sample-image">
                    <img :src="image" alt="" :width="item.imageWidth" :height="item.imageHeight">
                  </div>
                  <div class="sample-materials">
                    <div class="title h3">Select Material</div>
                    <ul>
                        <li v-for="material in availableMaterials.slice(0, 4)" :key="material.id">
                        <input 
                            :id="material.id" 
                            type="checkbox" 
                            :value="material.value" 
                            v-model="materials" 
                            class="checkbox">
                        <label :for="material.id">{{ material.label }}</label>
                        <span v-if="material.badge" class="material-badge">{{ material.badge }}</span>
                        </li>
                    </ul>
                    <a v-if="availableMaterials.length > 4" href="#additonal-materials" role="button"  @click.prevent="tabs.additional_materials.collapsed = !tabs.additional_materials.collapsed" :class="{'collapsed':tabs.additional_materials.collapsed}">Additional Materials</a>
                    <ul v-if="availableMaterials.length > 4" id="additonal-materials" class="collapse" :class="{'in':!tabs.additional_materials.collapsed}">
                        <li v-for="material in availableMaterials.slice(4)" :key="material.id">
                        <input 
                            :id="material.id" 
                            type="checkbox" 
                            :value="material.value" 
                            v-model="materials" 
                            class="checkbox">
                        <label :for="material.id">{{ material.label }}</label>
                        <span v-if="material.badge" class="material-badge">{{ material.badge }}</span>
                        </li>
                    </ul>
                    <p class="error" v-if="errors">Please select sample material</p>
                    <div class="actions canvas-extra">
                        <a v-if="!isWallpaper" href="#" class="action action--compare extra-link" @click.stop.prevent="close(); openCompareModal()"><span>Compare Materials</span>
                            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>
                        </a>
                        <button type="submit" class="action action--submit button extra-link"><span>Order Sample | $10</span>
                            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg>
                        </button>
                    </div>
                  </div>
                  <div class="sample-materials sample-materials--infos">
                    <div class="title h3">See It In Your Space</div>
                    <p class="sample-materials--info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15.006" viewBox="0 0 20 15.006">
                            <g id="truck" transform="translate(0 -6)">
                                <g id="Group_188" data-name="Group 188" transform="translate(0 6)">
                                <path id="Path_196" data-name="Path 196" d="M0,7.875A1.875,1.875,0,0,1,1.875,6h11.25A1.875,1.875,0,0,1,15,7.875V9.75h1.275a1.875,1.875,0,0,1,1.463.7l1.851,2.313A1.875,1.875,0,0,1,20,13.939v2.686A1.875,1.875,0,0,1,18.125,18.5H17.5a2.5,2.5,0,0,1-5,0H6.25a2.5,2.5,0,1,1-5-.106A1.875,1.875,0,0,1,0,16.625Zm1.617,9.32a2.5,2.5,0,0,1,4.3.055h6.92a2.512,2.512,0,0,1,.915-.915V7.875a.625.625,0,0,0-.625-.625H1.875a.625.625,0,0,0-.625.625v8.75a.625.625,0,0,0,.367.57ZM15,16a2.5,2.5,0,0,1,2.165,1.25h.96a.625.625,0,0,0,.625-.625V13.937a.625.625,0,0,0-.137-.39l-1.85-2.312A.625.625,0,0,0,16.275,11H15ZM3.75,17.25A1.25,1.25,0,1,0,5,18.5,1.25,1.25,0,0,0,3.75,17.25Zm11.25,0a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,15,17.25Z" transform="translate(0 -6)"/>
                                </g>
                            </g>
                        </svg>
                        Free shipping in the U.S.A.
                    </p>
                    <p class="sample-materials--info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.797" height="16.797" viewBox="0 0 16.797 16.797">
                            <g id="arrows-fullscreen" transform="translate(-0.075 -0.075)">
                                <g id="Group_198" data-name="Group 198" transform="translate(0.075 0.075)">
                                <path id="Path_207" data-name="Path 207" d="M6.186,10.761a.527.527,0,0,0-.745,0L1.128,15.074V12.159a.527.527,0,0,0-1.053,0v4.186a.527.527,0,0,0,.527.527H4.788a.527.527,0,0,0,0-1.053H1.873l4.313-4.313A.527.527,0,0,0,6.186,10.761Zm4.575,0a.527.527,0,0,1,.745,0l4.313,4.313V12.159a.527.527,0,0,1,1.053,0v4.186a.527.527,0,0,1-.527.527H12.159a.527.527,0,0,1,0-1.053h2.915l-4.313-4.313A.527.527,0,0,1,10.761,10.761Zm0-4.575a.527.527,0,0,0,.745,0l4.313-4.313V4.788a.527.527,0,0,0,1.053,0V.6a.527.527,0,0,0-.527-.527H12.159a.527.527,0,0,0,0,1.053h2.915L10.761,5.442A.527.527,0,0,0,10.761,6.186Zm-4.575,0a.527.527,0,0,1-.745,0L1.128,1.873V4.788a.527.527,0,1,1-1.053,0V.6A.527.527,0,0,1,.6.075H4.788a.527.527,0,1,1,0,1.053H1.873L6.186,5.442A.527.527,0,0,1,6.186,6.186Z" transform="translate(-0.075 -0.075)" fill-rule="evenodd"/>
                                </g>
                            </g>
                        </svg>
                        Scaled to show the entire image
                    </p>
                    <p class="sample-materials--info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="17.088" height="17.088" viewBox="0 0 17.088 17.088">
                            <g id="checkmark-outline" transform="translate(-3 -3)">
                                <path id="Path_208" data-name="Path 208" d="M16.333,23.309,13.5,20.039l.8-.924,2.033,2.345,4.3-4.96.8.925Z" transform="translate(-5.923 -8.24)"/>
                                <path id="Path_209" data-name="Path 209" d="M11.544,3a8.544,8.544,0,1,0,8.544,8.544A8.544,8.544,0,0,0,11.544,3Zm0,15.867a7.323,7.323,0,1,1,7.323-7.323A7.323,7.323,0,0,1,11.544,18.867Z" transform="translate(0 0)"/>
                            </g>
                        </svg>
                        Test the ease of installation
                    </p>
                  </div>
                </div>
              </form>
            </div>          
          </div>
          <button class="modal-close button button--close" @click="close()"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg></button>
        </div>
      </div>
    </div>
    </transition>`,
    watch: {
        materials(newNaterials) {
            if(newNaterials.length > 0) {
                this.errors = null;
            }
        },
    },
    computed: {
        showModal() {
            return store.getters['samplePopup/show'];
        },
        item() {
            return store.getters['samplePopup/item'];
        },
        croppedFile() {
            return store.getters['samplePopup/croppedFile'];
        },
        files() {
            return store.getters['samplePopup/files'];
        },
        isWallpaper() {
            return this.item && this.item.type === 'wallpaper';
        },
        isGridItem() {
            return this.item && this.item.hasOwnProperty('isGridItem') && this.item.isGridItem === true;
        },
        availableMaterials() {
            const category = this.isWallpaper ? 'wallpaper' : 'mural';
            const materials = getSampleMaterialsData()
                .filter(material => material.category === category)
                .sort((a, b) => (a.position || 0) - (b.position || 0));

            if (materials.length > 0) {
                return materials;
            }

            // Fallback to the original defaults if the "sample_material" metaobject
            // has not been populated yet, so the sample popup never renders empty.
            if (this.isWallpaper) {
                return [
                    { id: 'sample-fabric-paste', value: 'Fabric (Peel & Stick)', label: 'Fabric (Peel & Stick)', badge: 'Most Popular' },
                    { id: 'sample-fabric-canvas', value: 'Premium Canvas (Paste Required)', label: 'Premium Canvas (Paste Required)' },
                    { id: 'sample-fabric-paper', value: 'Paper (Paste Required)', label: 'Paper (Paste Required)' },
                    { id: 'sample-linen', value: 'Linen (Paste Required)', label: 'Linen (Paste Required)' }
                ];
            } else {
                return [
                    { id: 'sample-fabric', value: 'Fabric (Peel & Stick)', label: 'Fabric (Peel & Stick)', badge: 'Most Popular' },
                    { id: 'sample-canvas', value: 'Premium Canvas (Peel & Stick)', label: 'Premium Canvas (Peel & Stick)' },
                    { id: 'sample-vinyl', value: 'Vinyl (Paste Required)', label: 'Vinyl (Paste Required)' },
                    { id: 'sample-paper', value: 'Paper (Paste Required)', label: 'Paper (Paste Required)' },
                    { id: 'sample-linen', value: 'Linen (Paste Required)', label: 'Linen (Paste Required)' },
                    { id: 'sample-non-adhesive-canvas', value: 'Premium Canvas (Paste Required)', label: 'Premium Canvas (Paste Required)' }
                ];
            }
        },
        image() {
            if(this.item) {
                if(this.item.custom === true && this.croppedFile) {
                    return URL.createObjectURL(this.croppedFile);
                } else if(this.item.thumbnail_url) {
                    return this.item.thumbnail_url;
                } else {
                    return this.item.url;
                }
            }
        },
        showComparePopup() {
            return store.getters['modal/showComparePopup'];
        },
    },
    methods: {
        close() {
            store.dispatch('samplePopup/close')
        },
        onSubmit() {
            if(this.materials.length === 0) {
                this.errors = true;
                return false;
            } else {
                this.loading = true;
                let properties = {
                    '_id': this.item.hasOwnProperty('custom') && this.item.custom ? 'custom' : this.item.id,
                    '_entity_id': this.item.hasOwnProperty('entity_id') && this.item.entity_id ? this.item.entity_id : null,
                    '_sku': this.item.hasOwnProperty('sku') && this.item.sku ? this.item.sku : this.item.custom ? 'custom' : this.item.id,
                    '_original_image': this.isGridItem ? this.item.thumbnail_url : this.item.original_image || this.item.url,
                    '_product_url': this.isGridItem ? this.item.productUrl : window.location.href.split('?')[0],
                    '_url_key': this.item.hasOwnProperty('url_key') && this.item.url_key ? this.item.url_key : null,
                    '_name': this.item.title + ' Sample',
                    '_quantity': 1,
                    '_type': 'sample',
                    'Materials': this.materials.join(', ')
                };
                // Only add cropped image for non-wallpaper products
                if (!this.isWallpaper && document.getElementById('cropped-image')) {
                    properties['_cropped_image'] = document.getElementById('cropped-image').value;
                }
                if(this.files && this.files[0]) {
                    properties['_uploaded_image'] = this.files[0];
                }
                if(this.croppedFile) {
                    properties['_cropped_image'] = this.croppedFile;
                }

                // Detect product type and use appropriate window variables
                let variantId, variantPrice, variantWeight;
                if (this.item && this.item.type === 'wallpaper') {
                    variantId = window.wallpaperSampleVariantId;
                    variantPrice = window.wallpaperSampleVariantPrice;
                    variantWeight = window.wallpaperSampleVariantWeight;
                } else {
                    variantId = window.sampleVariantId;
                    variantPrice = window.sampleVariantPrice;
                    variantWeight = window.sampleVariantWeight;
                }

                const data = {
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: properties
                    }]
                };

                let image = this.isGridItem ? this.item.thumbnail_url : this.item.original_image || this.item.url;
                if(this.item.custom === true) {
                    image = this.item.url || this.item.upload;
                }

                const submitData = new FormData();
                submitData.set('id',properties['_id']);
                submitData.set('sku',properties['_sku']);
                submitData.set('type','Sample');
                submitData.set('title',this.item.title + ' Sample');
                submitData.set('size','Sample');
                submitData.set('correctedPrice',variantPrice);
                submitData.set('weight',variantWeight);
                submitData.set('image',image);

                const formData = new FormData();
                formData.set('id',variantId);
                formData.set('quantity',1);

                for(const key in properties) {
                    formData.set(`properties[${key}]`,properties[key]);
                }
                store.dispatch('samplePopup/add', {'cart': data, 'form': formData, 'additional': submitData});
            }
        },
        openCompareModal() {
            store.dispatch('modal/openComparePopup');
        },
        closeCompareModal() {
            store.dispatch('modal/closeComparePopup');
        },
    }
})
samplePopupApp.use(AdobeClientPlugin).use(store);
samplePopupApp.mount('#sample-popup-app');
